var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedWishList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19590",
    "data-name": "Group 19590",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.969,
    x2: 0.5,
    y2: 0.018,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd3a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa68d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M2798-3109a15.9,15.9,0,0,1-11.314-4.687A15.894,15.894,0,0,1,2782-3125a15.9,15.9,0,0,1,4.686-11.314A15.9,15.9,0,0,1,2798-3141a15.9,15.9,0,0,1,11.314,4.686A15.9,15.9,0,0,1,2814-3125a15.894,15.894,0,0,1-4.687,11.313A15.9,15.9,0,0,1,2798-3109Zm0-29a13.015,13.015,0,0,0-13,13,13.015,13.015,0,0,0,13,13,13.014,13.014,0,0,0,13-13A13.015,13.015,0,0,0,2798-3138Z",
    transform: "translate(-2782 3141)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-mark_1_",
    "data-name": "check-mark (1)",
    transform: "translate(9 5.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756",
    transform: "translate(0 5.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4889",
    "data-name": "Path 4889",
    d: "M6.7,16.347a1.719,1.719,0,0,1-2.431,0L.5,12.58A1.719,1.719,0,0,1,2.934,10.15l2.244,2.244a.435.435,0,0,0,.614,0l6.076-6.076A1.719,1.719,0,1,1,14.3,8.748Z",
    transform: "translate(0 -5.814)",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedWishList);
export default __webpack_public_path__ + "static/media/checked-wish-list.189c0f2cc7cc30deee9c4c1a03c11749.svg";
export { ForwardRef as ReactComponent };